import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function OwnerRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) return <div className="grid min-h-screen place-items-center text-sm text-muted-foreground">Загрузка…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "owner") return <Navigate to="/hall" replace />;
  return children;
}
